import TicketDetail from './ticket-detail-container';

export default TicketDetail;
